<template>
    <div class="shipping-options">
        <div v-if="loading">
            <strong>Select a shipping method</strong>
            <br/>
            Loading...
            <loaders loader="rolling"></loaders>
        </div>
        <div v-else>
            <div v-if="shippingMethod !== false">
                <strong>Shipping Method</strong>
                <br/>
                <div class="shipping-method">
                    <img v-if="shippingMethod.provider === 'UPS'" src="/static/ups.svg">
                    <img v-if="shippingMethod.provider === 'USPS'" src="/static/usps.svg">
                    <div>
                        {{ shippingMethod.provider }} {{ shippingMethod.name }}
                        - {{ shippingMethod.amount | currency }}
                        <br/>
                        Delivery in <strong>{{ shippingMethod.estimate + 5 }} - {{ shippingMethod.estimate + 7 }} days</strong>
                    </div>
                </div>
                <hr/>
                <em>Delivery is an estimate based on manufacturing turnaround time.</em>
                <br/>
                <br/>
                <button class="button btn-sm" @click="clearOption()">Change Service</button>
            </div>
            <div v-else>
                <strong>Select a shipping method</strong>
                <br/>
                <div v-if="shippingMethods.length < 1">
                    Hmmm... The shipping methods couldn't be loaded.
                    <br/>
                    <br/>
                    <button class="button btn-sm" @click="loadMethods()">Retry</button>
                    <br/>
                </div>
                <div v-else>
                    <div v-for="method in sortedShippingMethods" class="shipping-option" @click="setOption(method.token)">
                        <img v-if="method.provider === 'UPS'" src="/static/ups.svg">
                        <img v-if="method.provider === 'USPS'" src="/static/usps.svg">
                        <div>
                            <strong>{{ method.provider }} {{ method.name }}</strong>
                            <br/>
                            {{ method.estimate }} business days - {{ method.amount | currency }}
                        </div>
                    </div>
                    <em>Depending on our available stock, please allow <strong style="color: #D33;">up to 5 extra business days</strong> for manufacturing lead time!</em>
                </div>
            </div>
        </div>
        <br/>
    </div>
</template>

<style lang="scss">
    $shipping-border-color: #ccc;
    .shipping-method {
        & > img {
            display: inline-block;
            vertical-align: middle;
            max-width: 25px;
        }
        & > div {
            display: inline-block;
            vertical-align: middle;
        }
    }
    .shipping-option {
        padding: 0.25rem 0.5rem;
        &:hover {
            color: #000;
            background-color: #99ccff;
            cursor: pointer;
        }
        &:not(:last-child) {
            border-bottom: 1px solid $shipping-border-color;
        }
        & > img {
            display: inline-block;
            vertical-align: middle;
            max-width: 25px;
        }
        & > div {
            display: inline-block;
            vertical-align: middle;
        }
    }
    .shipping-provider {
        &:not(:last-child) {
            border-bottom: 1px solid $shipping-border-color;
        }
    }

</style>

<script>
    import {mapGetters} from "vuex"
    import * as types from "../store/types"

    export default {
        name: 'ShippingOptions',
        data() {
            return {
                loading: false,
            }
        },
        mounted() {
            if (this.$store.state.cart.shipping.method === false) {
                this.loadMethods();
            }
        },
        computed: mapGetters(['shippingMethod', 'sortedShippingMethods', 'shippingMethods', 'cartItems']),
        methods: {
            loadMethods() {
                if(this.cartItems.length < 1) {
                    this.$router.push({name:'order'});
                    return;
                }
                this.loading = true
                this.$store.dispatch(types.FETCH_SHIPPING_METHODS)
                    .then(data => {
                        this.loading = false
                    })
                    .catch(data => {
                        this.loading = false
                    })
            },
            setOption(token) {
                this.loading = true;
                this.$store.dispatch(types.SET_SHIPPING_METHOD, token)
                    .then(data => {
                        this.loading = false
                    })
                    .catch(data => {
                        this.loading = false
                    })
            },
            clearOption() {
                this.loading = true;
                this.$store.dispatch(types.CLEAR_SHIPPING_METHOD)
                    .then(data => {
                        if (this.$store.state.shipping.methods.length < 1) {
                            this.loadMethods();
                        } else {
                            this.loading = false
                        }
                    })
                    .catch(data => {
                        this.loading = false
                    })
            }
        },
        watch: {
            '$store.state.cart.items': 'loadMethods'
        }
    }
</script>


// WEBPACK FOOTER //
// ShippingOptions.vue?10c42c46